const workercode = () => {
  self.onmessage = e => {
    const model = e.data.demoAttributes
      .filter(item => item.name === "Auto")[0]
      .attributes.filter(item => item.name === "Auto Model")[0]
      .values.filter(
        item =>
          item.label.split(" - ")[0].toLowerCase() ===
          e.data.makeObj.label.toLowerCase(),
      );

    let selected = e.data.selected_segments ? e.data.selected_segments : [];

    function chooseSegmentValues(id, ifAdd) {
      if (ifAdd) {
        selected.push(id);
      } else {
        let idx = selected ? selected.indexOf(id) : -1;
        if (idx >= 0) {
          selected.splice(idx, 1);
        }
      }
    }

    model.forEach(item => {
      chooseSegmentValues(item.id, false);
    });

    self.postMessage(selected);
  };
};

let code = workercode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);

export default worker_script;



// WEBPACK FOOTER //
// ./src/components/Segment/Creation/AutoMake/worker.js